var React = require('react');

function IconPlus (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Plus Icon"),React.createElement("g",{"id":"teamawesome-team-members","transform":"translate(-1101.000000, -182.000000)","key":1},React.createElement("g",{"id":"New-Humanoid","transform":"translate(1087.000000, 169.000000)"},React.createElement("path",{"d":"M20,17 L24,17 L24,19 L20,19 L20,23 L18,23 L18,19 L14,19 L14,17 L18,17 L18,13 L20,13 L20,17 Z","id":"Plus-Icon"})))]);
}

IconPlus.defaultProps = {"width":"10px","height":"10px","viewBox":"0 0 10 10","version":"1.1"};

module.exports = IconPlus;

IconPlus.default = IconPlus;
